export default __webpack_public_path__ + "static/media/img_3.a49e3d4b.jpg";